import { axios } from '@/utils/request'
const api = "/GoodsCats"
export default {
  GoodsCatsList: (parameter) => {
    return axios({
      url: `${api}/GoodsCatsList`,
      method: 'post',
      data: parameter
    })
  },
  deleteGoodsCats: (parameter) => {
    return axios({
      url: `${api}/deleteGoodsCats`,
      method: 'post',
      data: parameter
    })
  },
  SaveGoodsCats: (parameter) => {
    return axios({
      url: `${api}/SaveGoodsCats`,
      method: 'post',
      data: parameter
    })
  },
  AddGoodsCats: (parameter) => {
    return axios({
      url: `${api}/AddGoodsCats`,
      method: 'post',
      data: parameter
    })
  },
  FindGoodsCats: (parameter) => {
    return axios({
      url: `${api}/FindGoodsCats`,
      method: 'post',
      data: parameter
    })
  },

}